<script lang="js" setup>
import { useDocumentVisibility } from '@vueuse/core'
import { getOverview } from '@/apis/referral'
import { useUserStore } from '@/store/user'
import { inApp } from '@/utils/inApp'
import { callHandler, nativeGoBack } from '@/utils/JSbridge'
import webPage from '@/components/referral/index.vue'
import h5Page from '@/components/referral/h5/index.vue'

definePageMeta({
  stickyHeader: true,
  supportMobile: true,
  needLogin: true,
})
const { t } = useI18n()
const user = useUserStore()
const overview = ref({ loading: true })
const visibility = useDocumentVisibility()

watch(() => user.isLogin, (nv) => {
  if (nv) {
    queryOverview()
  }
}, { immediate: true })

async function queryOverview() {
  const { data = {} } = await getOverview() || {}
  overview.value = data
}

if (import.meta.client && inApp) {
  callHandler({
    uri: 'window',
    method: 'nativeSetTitle',
    data: { title: t('邀请好友') },
  })

  watch(visibility, (newVisibility) => {
    if (newVisibility === 'visible') {
      if (!user.isLogin) {
        nativeGoBack()
      }
    }
  })
}
</script>

<template>
  <ClientOnly>
    <div v-if="user.isLogin">
      <webPage class="hidden md:block" :overview="overview" />
      <h5Page class="md:hidden" :overview="overview" />
    </div>
  </ClientOnly>
</template>
